import React, { useEffect, useState } from "react";
import {
  Container,
  Table,
  Button,
  Form,
  Row,
  Col,
  Pagination,
} from "react-bootstrap";
import { FiEdit, FiTrash2, FiPlus, FiSearch, FiFile } from "react-icons/fi";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { getDiaryNote, } from "../../store/slices/diaryNote";

export default function StudentDiaryNote() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const activeStudent = useSelector(
    (state) => state.activestudent?.student
  );

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;
  const [totalData, setTotalData] = useState(0);

  /* >>>>>>>>>>>> Fetch Diary Notes ---------- */
  const fetchDiaryNotes = (students) => {
    if (!students) return;

    setIsLoading(true);

 
    dispatch(getDiaryNote({ students }))
      .unwrap()
      .then((res) => {
        setData(res?.data || []);
        setTotalData(res?.totalDataCount || 0);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to fetch diary notes");
        setData([]);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    const studentId = activeStudent?._id;

    if (!studentId) return;

    fetchDiaryNotes(studentId);
    setCurrentPage(1);
  }, [activeStudent?._id]);

  console.log("diarydata:", data);

  // Edit
//   const editNavigatedata = (id) => {
//     navigate(`/teacher/edit-diarynote/${id}`);
//     console.log("diary edit id :", id)
//   };

  // Delete
//   const handleDeleteRow = (id) => {
//     if (!window.confirm("Are you sure you want to delete this diary note?"))
//       return;

//     dispatch(deletediarynote(id))
//       .unwrap()
//       .then(() => {
//         toast.success("Diarynote deleted successfully");
//         fetchDiaryNotes(activeStudent?._id);
//       })
//       .catch(() => {
//         toast.error("Failed to delete diary note");
//       });
//   };

  // date format
  const formatDate = (isoDate) => {
    if (!isoDate) return "-";
    return new Date(isoDate).toLocaleDateString("en-GB");
  };

  // ---- >Pagination
  const totalPages = Math.ceil(totalData / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = data.slice(startIndex, startIndex + itemsPerPage);

  return (
    <Container>
      {/* Header */}
      <div className="staff-header">
        <div className="staff-breadcrumb">
          <Link to="/institute/home" className="crumb home">
            Home
          </Link>
          <span className="crumb current">Diary Notes</span>
        </div>

        {/* <div className="staff-header-right">
          <Link to="/teacher/add-diarynote" className="btn-submit">
            <FiPlus /> Add Diary
          </Link>
        </div> */}
      </div>

      {/* Card */}
      <div className="staff-card">
        <Row className="align-items-center mb-3">
          <Col md={4}>
            <h6 className="staff-card-title">Daily Diary Entries</h6>
          </Col>

          <Col md={8} className="staff-tools">
            <div className="staff-search">
              <FiSearch />
              <input placeholder="Search diary note" />
            </div>
          </Col>
        </Row>

        {/* Table */}
        <div className="table-responsive">
          <Table className="staff-table align-middle">
            <thead>
              <tr>
                <th><Form.Check /></th>
                <th>#</th>
                <th>Date</th>
                <th>Diary Note</th>
                <th>Files</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>

            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="6" className="text-center py-3">
                    Loading...
                  </td>
                </tr>
              ) : paginatedData.length > 0 ? (
                paginatedData.map((item, i) => (
                  <tr key={item._id}>
                    <td><Form.Check /></td>
                    <td>{startIndex + i + 1}</td>
                    <td>{formatDate(item.date)}</td>
                    <td
                      className="text-truncate"
                      style={{ maxWidth: "300px" }}
                    >
                      {item.diaryNote}
                    </td>
                    <td>
                      {item.files?.length > 0
                        ? item.files.map((file, index) => (
                            <a
                              key={index}
                              href={file}
                              target="_blank"
                              rel="noreferrer"
                              style={{ marginRight: "8px" }}
                            >
                              <FiFile />
                            </a>
                          ))
                        : "-"}
                    </td>

                    {/* <td className="staff-actions">
                      <FiTrash2
                        onClick={() => handleDeleteRow(item._id)}
                      />
                      <FiEdit
                        onClick={() => editNavigatedata(item._id)}
                      />
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-3">
                    No diary notes found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {/* Pagination */}
        <div className="d-flex flex-row-reverse my-3">
          <Pagination>
            <Button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
              style={{
                background: "transparent",
                color: "#8451ff",
                borderRadius: "15px",
              }}
            >
              <IoIosArrowBack />
            </Button>

            <Button active disabled className="mx-1" style={{ borderRadius: "20px" }}>
              {currentPage}
            </Button>

            <Button
              disabled={
                currentPage === totalPages || paginatedData.length === 0
              }
              onClick={() => setCurrentPage((p) => p + 1)}
              style={{
                background: "transparent",
                color: "#8451ff",
                borderRadius: "15px",
              }}
            >
              <IoIosArrowForward />
            </Button>
          </Pagination>
        </div>
      </div>
    </Container>
  );
}
